/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.list.categories.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.partners.list.categories.createModal.controllers',
  'acme.view.application.partners.list.categories.removeModal.controllers',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('PartnersListCategoriesController', ['$scope', '$state', '$timeout', '$filter', '$uibModal', 'ApiService', 'ValidateService', 'PermissionsService', 'HelpersService', 'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory', function($scope, $state, $timeout, $filter, $uibModal, ApiService, ValidateService, PermissionsService, HelpersService, NoticeFactory, GridStateFactory, GridDefinitionFactory) {

    $scope.partnersListCategories = {

      model: [],
      original: [],
      filtered: [],
      updateCache: [],
      currentCategory: {},
      searchQuery: '',
      viewId: '',
      isRemoving: false,
      isUpdated: true,
      isLoaded: false,
      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      partnersListCategoriesGridName: $state.current.name+'.grid0',
      
      optionsOverride: {
        useAccessibleGrid: true,
        data: 'partnersListCategories.model',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.partnersListCategories.onDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.partnersListCategories.onDataGridSortChange(grid, columns);
          },
          onAfterCellEdit: function (rowEntity, colDef, newVal, oldVal) {
            $scope.partnersListCategories.onAfterCellEdit(rowEntity, colDef, newVal, oldVal);
          },
          remove: function (id) {
            $scope.partnersListCategories.remove(id);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true
          },
          {
            field: 'description',
            displayName: 'Description',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true
          },
          {
            field: 'code',
            displayName: 'GL Code',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            visible: false
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Organization Categories',
          buttonRight: {
            permissions: 'ACCT_CATEGORIES_CREATE',
            label: '+ Create Category',
            action: function() {
              $scope.partnersListCategories.create();
            }
          }
        });

        
        this.viewId = $state.current.name;

        if (PermissionsService.check('ACCT_CATEGORIES_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.partnersListCategories.optionsOverride.appScopeProvider.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><a class="partners-list-categories-remove" data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        this.gridDefinition.init(this.partnersListCategoriesGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('$destroy', $scope.$watch('partnersListCategories.searchQuery', function(n, o) {
          var self = $scope.partnersListCategories;

          if (n !== o) {
            self.getPartnerCategories(self.gridState);
          }
        }));
        
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

      },

      initData: function() {
        var self = $scope.partnersListCategories, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getPartnerCategories($scope.partnersListCategories.gridState.getGridState());
      },

      hasCategories: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      search: function() {
        this.filtered = $filter('filter')(this.model, function(category) {
          var name = category.name + '|' + category.description + '|' + category.code,
            value = (name).toLowerCase();
          return (value.indexOf($scope.partnersListCategories.searchQuery.toLowerCase()) !== -1) ? category : null;
        });
      },
      
      getPartnerCategories: function (query) {
        var state = angular.copy(query);

        state.search = this.searchQuery;

        return ApiService.partners.categories.list(state).then(this.success.getPartnerCategories, this.error.getPartnerCategories);
      },

      findCategoryById: function(id, list) {
        var i, ii,
            r = false;

        list = list || this.model;

        for (i=0,ii=list.length;i<ii;i++) {
          if (list[i].id === id) {
            r = {
              index: i,
              category: list[i]
            };
            break;
          }
        }
        return r;
      },

      remove: function(id) {
        var self = $scope.partnersListCategories,
            current = self.findCategoryById(id);

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/list/categories/modals/removeCategory.tpl.html',
          size: 'md',
          controller: 'PartnersListCategoriesRemoveModalController',
          resolve: {
            currentCategory: function() {
              return current.category;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function () {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isRemoving = true;

          ApiService.partners.categories.remove(current.category.id).then(function(response) {
            self.model.splice(current.index, 1);
            self.success.remove(response);
          }, self.error.remove);
        }, function () {
          // Do nothing
        });

      },

      create: function() {

        var self = $scope.partnersListCategories;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/list/categories/modals/createCategory.tpl.html',
          size: 'lg',
          controller: 'PartnersListCategoriesCreateModalController',
          resolve: {
            categoriesList: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (category) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.partners.categories.create(category).then(function(response) {
            if (response.data.payload.id) {
              category.id = response.data.payload.id;
            }
            self.model.push(category);
            self.success.create(response);
          }, self.error.create);
        }, function () {
          // Do nothing
        });

      },

      update: function() {

        if (!this.isUpdated) {
          this.notice.hideSuccessMessages();
          this.notice.hideErrorMessages();

          while (this.updateCache.length > 0) {
            ApiService.partners.categories.update(this.findCategoryById(this.updateCache.pop()).category).then(this.success.update, this.error.update);
          }
        }

      },

      cancel: function() {
        this.isUpdated = true;
        this.model = angular.copy(this.original);
        this.search();
      },

      onAfterCellEdit: function(rowEntity, colDef, newVal, oldVal) {
        var current, changed,
            self = $scope.partnersListCategories;

        console.log('PartnersListCategoriesController::onCellInputEdit', rowEntity);

        // Copy from the filtered edited version back to the model
        current = self.findCategoryById(rowEntity.id);
        changed = self.findCategoryById(rowEntity.id, self.filtered);
        self.model[current.index] = angular.copy(self.filtered[changed.index]);

        // Add it to the update cache
        if (self.updateCache.indexOf(rowEntity.id) === -1) {
          self.updateCache.push(rowEntity.id);
        }

        if (self.updateCache.length > 0) {
          $scope.partnersListCategories.isUpdated = false;
        }
      },

      success: {
        init: function () {},
        getPartnerCategories: function (response) {
          var self = $scope.partnersListCategories,
              categories = response.data.payload;

          self.model = categories.list;
          self.original = angular.copy(categories.list);
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;
          if (!$scope.$$phase) {
            $scope.$apply();
          }
          
          //wait for next tick
          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          },10);
          self.search();
        },

        create: function(response) {
          var self = $scope.partnersListCategories;

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: self.gridDefinition.options.totalItems+1});
          },10);
          $scope.partnersListCategories.notice.showSuccessMessages([{
            message: 'Successfully Created!'
          }]);
          $timeout(function() {
            $scope.partnersListCategories.notice.hideSuccessMessages();
          }, 3000);
        },
        remove: function(response) {
          var self = $scope.partnersListCategories;

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: self.gridDefinition.options.totalItems-1});
          },10);
          $scope.partnersListCategories.isRemoving = false;
          $scope.partnersListCategories.notice.showSuccessMessages([{
            message: 'Successfully Removed!'
          }]);

          $timeout(function() {
            $scope.partnersListCategories.notice.hideSuccessMessages();
          }, 3000);
        },
        update: function(response) {
          $scope.partnersListCategories.notice.showSuccessMessages([{
            message: 'Successfully Updated!'
          }]);

          if ($scope.partnersListCategories.updateCache.length === 0) {
            $scope.partnersListCategories.isUpdated = true;
            $scope.partnersListCategories.original = angular.copy($scope.partnersListCategories.model);

            $timeout(function () {
              $scope.partnersListCategories.notice.hideSuccessMessages();
            }, 3000);
          }
        }
      },

      error: {
        init: function(response) {
          $scope.partnersListCategories.grid.isLoaded = true;
          $scope.partnersListCategories.handleError.call(null, response);
        },
        create: function(response) {
          $scope.partnersListCategories.handleError.call(null, response);
        },
        remove: function(response) {
          $scope.partnersListCategories.isRemoving = false;
          $scope.partnersListCategories.handleError.call(null, response);
        },
        update: function(response) {
          $scope.partnersListCategories.handleError.call(null, response);
        },
        getPartnerCategories: function (response) {
          $scope.partnersListCategories.handleError.call(null, response);
        }
      },
      
      onDataGridPaginate: function (newPageNumber, pageSize) {
        var self = $scope.partnersListCategories;

        self.gridState.updateGridState(newPageNumber, pageSize);
        self.getPartnerCategories(self.gridState);
      },
      
      onDataGridSortChange: function (grid, columns) {
        var self = $scope.partnersListCategories,
            data = columns[0];

        self.gridState.updateGridState(null, null, data.field, data.sort.direction);
        self.getPartnerCategories(self.gridState.getGridState());
      },
      
      handleError: function (response) {
        $scope.partnersListCategories.notice.showErrorMessages([
          { message: response.data.error }
        ]);
      },
      
      onSelectedCategoryUpdate: function(n, o) {
        if (n !== o) {
          ViewStateService.setStateProperty('partners.list','page', 0);
          $scope.partnersListCategories.setDataForGrid();
        }
      }

    };

    $scope.partnersListCategories.init();

}]);